import TYPE from 'redhotpie-shared-lib/constants/newFeed';
import Immutable from 'seamless-immutable';
import * as types from '../constants/actionTypes';
import { COMMUNITY_DATA_KEY, FROM_DELETE_COMMENT } from '../constants/constants';
import { getKeyOTG } from '../functions/utils';
import initialState from './initialState';
// import _ from "lodash";

export default function communityReducer(state = initialState.communityState, action) {
  switch (action.type) {
    case types.UPDATE_COMMUNITY_STORY_ID_SELECTED: {
      return state.set('storyIdSelected', action.data);
    }
    case types.UPDATE_COMMUNITY_STATE: {
      console.log(action);
      return state.merge({ ...action.data });
    }

    case types.GET_ARTICLE_CATEGORIES_COUNT_SUMMARY: {
      return state.setIn(['article', 'categoriesData'], action.data);
    }

    case types.DELETE_OTG_GALLERY_LIKE: {
      return state.set('otgPhoto', {
        ...state.otgPhoto,
        data: state.otgPhoto.data.map(p => {
          return {
            ...p,
            contentItem: {
              ...p.contentItem,
              isMemberLike: false,
              likeCount: p.contentItem.isMemberLike ? p.contentItem.likeCount - 1 : p.contentItem.likeCount,
            },
          };
        }),
      });
    }

    case types.GET_QUESTION_AND_ANSWER_CATEGORIES_COUNT_SUMMARY: {
      return state.setIn(['questionAndAnswer', 'categoriesData'], action.data);
    }

    case types.GET_STORY_CATEGORIES_COUNT_SUMMARY: {
      return state.setIn(['stories', 'categoriesData'], action.data);
    }

    case types.LOADING_COMMUNITY_DETAILS: {
      const { isLoading } = action;
      return state.merge({
        communityDetail: {
          isLoading,
          typeName: null,
          contentItem: {},
        },
      });
    }
    case types.LOADING_OTG_PHOTO_DETAILS: {
      const { isLoading } = action;
      return state.merge({
        otgPhoto: {
          data: [],
          page: 1,
          isHasMore: true,
          isLoading,
        },
      });
    }

    case types.GET_QUESTION_AND_ANSWER: {
      const { questionAndAnswer } = Immutable.asMutable(state);
      const { params, data } = action;
      const size = (params && params.size) || 20;
      const updateObject = {
        questionAndAnswer: {
          ...questionAndAnswer,
          data: !params || (params && !params.page) || (params && params.page === 1) ? data : [...questionAndAnswer.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMore: data && data.length === size,
          category: (params && params.category) || 0,
        },
      };
      return state.merge({ ...updateObject });
    }

    case types.GET_ARTICLES: {
      const { article } = Immutable.asMutable(state);
      const { params, data } = action;
      const size = (params && params.size) || 20;
      const updateObject = {
        article: {
          ...article,
          data: !params || (params && !params.page) || (params && params.page === 1) ? data : [...article.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMore: data && data.length === size,
          category: (params && params.category) || 0,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_STORIES: {
      const { stories } = Immutable.asMutable(state);
      const { params, data } = action;
      const updateObject = {
        stories: {
          ...stories,
          data: !params || (params && !params.page) || (params && params.page === 1) ? data : [...stories.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMore: data && data.length >= 20,
          category: (params && params.category) || 0,
        },
      };
      return state.merge({ ...updateObject });
    }

    case types.GET_MY_STORIES: {
      const { myStories } = Immutable.asMutable(state);
      const { params, data } = action;
      const updateObject = {
        myStories: {
          ...myStories,
          // data: [],
          data: !params || (params && !params.page) || (params && params.page === 1) ? data : [...myStories.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMore: data && data.length >= 20,
        },
      };
      return state.merge({ ...updateObject });
    }

    case types.DELETE_STORIES: {
      const { myStories } = Immutable.asMutable(state);
      const updateObject = {
        myStories: {
          ...myStories,
          data: myStories.data.filter(item => action.data.indexOf(item.contentItem.id) === -1),
        },
      };
      return state.merge({ ...updateObject });
    }

    case types.GET_OTG_LIST: {
      // let {otg, otgGallery, otgVideo} = Immutable.asMutable(state);
      const { params, data } = action;
      const key = getKeyOTG(params);
      const dataState = getDataStateOTGByKey(key, Immutable.asMutable(state));
      const updateObject = {
        [key]: {
          ...dataState,
          data: !params || (params && !params.page) || (params && params.page === 1) ? data : [...dataState.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMore: data && data.length >= 20,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_OTG_PHOTOS: {
      const { otgPhoto } = Immutable.asMutable(state);
      const { params, data } = action;
      const updateObject = {
        otgPhoto: {
          ...otgPhoto,
          data: !params || (params && !params.page) || (params && params.page === 1) ? data : [...otgPhoto.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMore: data && data.length === 24,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_TESTIMONIAL: {
      const { testimonial } = Immutable.asMutable(state);
      const { params, data } = action;
      const updateObject = {
        testimonial: {
          ...testimonial,
          data: !params || (params && !params.page) || (params && params.page === 1) ? data : [...testimonial.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMore: data && data.length >= 20,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_COMMUNITY_DETAILS: {
      const { data } = action;
      let updateObject;
      if (data.typeName === TYPE.OTG_NAME.OTG_Photos) {
        updateObject = {
          communityDetailPhoto: {
            ...data,
            isLoading: false,
          },
        };
      } else {
        updateObject = {
          communityDetail: {
            ...data,
            isLoading: false,
          },
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.GET_COMMUNITY_COMMENTS: {
      const { communityDetailsComments } = Immutable.asMutable(state);
      const { data, params } = action;
      const isHasMore = data.comments && data.page < data.totalPages;
      const updateObject = {
        communityDetailsComments: {
          isLoading: false,
          comments: !params.page || params.page === 1 ? data.comments : [...communityDetailsComments.comments, ...data.comments],
          isHasMore,
          page: params.page || 1,
          totalItems: !params.page || params.page === 1 ? data.totalItems : communityDetailsComments.totalItems,
          totalPages: 0,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_OTG_PHOTOS_COMMENTS: {
      const { communityPhotoComments } = Immutable.asMutable(state);
      const { data, params } = action;
      console.log(types.GET_OTG_PHOTOS_COMMENTS, action, params);
      const isHasMore = data.comments && data.page < data.totalPages;
      const updateObject = {
        communityPhotoComments: {
          isLoading: false,
          comments: !params.page || params.page === 1 ? data.comments : [...communityPhotoComments.comments, ...data.comments],
          isHasMore,
          page: params.page || 1,
          totalItems: !params.page || params.page === 1 ? data.totalItems : communityPhotoComments.totalItems,
          totalPages: 0,
        },
      };
      return state.merge({ ...updateObject });
    }

    case types.UPDATE_COMMUNITY_DETAIL_COMMENT_FAILED: {
      return state
        .setIn(['communityDetailsComments', 'comments'], [])
        .setIn(['communityDetailsComments', 'isHasMore'], false)
        .setIn(['communityDetailsComments', 'totalItems'], 0)
        .setIn(['communityDetailsComments', 'totalPage'], 0)
        .setIn(['communityDetailsComments', 'isLoading'], false);
    }

    case types.UPDATE_LOADING_STATE: {
      const { key, status } = action;
      return state.setIn([key, 'isLoading'], status);
    }
    case types.GET_OTG_PHOTO_REPLY_SUCCESS: {
      // params = {
      //  size: size show reply,
      //  /* param for load more reply */
      //  commentParentID: id comment parent
      // }
      const { communityPhotoComments } = Immutable.asMutable(state);
      const newCommentParent = [];
      const items = (action.data && action.data.items) || [];
      if (action.params.commentParentID !== undefined) {
        // Function for load more
        communityPhotoComments.comments.forEach((evt, idx) => {
          if (evt.commentId === action.params.commentParentID) {
            evt = {
              ...evt,
              isHasMoreReply: items.length === (action.params.pageSize ? action.params.pageSize : 12),
              pageNumber: action.params.page >= 2 && items.length > 0 ? action.params.page : -1,
            };
          }
          newCommentParent.push(evt);
        });
      } else {
        communityPhotoComments.comments.forEach(evt => {
          const idComment = evt.commentId;
          let count = 0;
          items.forEach(itm => {
            if (itm.commentParentId === idComment) {
              count += 1;
            }
          });
          if (count >= (action.params.size ? action.params.size : 12)) {
            evt = {
              ...evt,
              isHasMoreReply: true,
              pageNumber: 1,
            };
          }
          newCommentParent.push(evt);
        });
      }

      return state.merge({
        communityPhotoComments: {
          ...communityPhotoComments,
          comments: [...newCommentParent, ...items],
        },
        dataCommentTmp: [...newCommentParent, ...items],
      });
    }
    case types.GET_REPLY_SUCCESS: {
      // params = {
      //  size: size show reply,
      //  /* param for load more reply */
      //  commentParentID: id comment parent
      // }
      const { communityDetailsComments } = Immutable.asMutable(state);
      const newCommentParent = [];
      const items = (action.data && action.data.items) || [];
      if (action.params.commentParentID !== undefined) {
        // Function for load more
        communityDetailsComments.comments.forEach((evt, idx) => {
          if (evt.commentId === action.params.commentParentID) {
            evt = {
              ...evt,
              isHasMoreReply: items.length === (action.params.pageSize ? action.params.pageSize : 12),
              pageNumber: action.params.page >= 2 && items.length > 0 ? action.params.page : -1,
            };
          }
          newCommentParent.push(evt);
        });
      } else {
        communityDetailsComments.comments.forEach(evt => {
          const idComment = evt.commentId;
          let count = 0;
          items.forEach(itm => {
            if (itm.commentParentId === idComment) {
              count += 1;
            }
          });
          if (count >= (action.params.size ? action.params.size : 12)) {
            evt = {
              ...evt,
              isHasMoreReply: true,
              pageNumber: 1,
            };
          }
          newCommentParent.push(evt);
        });
      }

      return state.merge({
        communityDetailsComments: {
          ...communityDetailsComments,
          comments: [...newCommentParent, ...items],
        },
        dataCommentTmp: [...newCommentParent, ...items],
      });
    }
    case types.GET_REPLY_SHOW_MORE_SHOW_LESS: {
      const { communityDetailsComments, dataCommentTmp } = Immutable.asMutable(state);
      const idCommentParent = action.params.commentParentID;
      const isShowMore = !communityDetailsComments.comments[action.params.index].isHasMoreReply;

      const idxCommentParent = action.params.index;
      let newDataEventComment = communityDetailsComments.comments.filter(itm => itm.commentParentId !== idCommentParent);
      let countReply = 0;
      const newDataEventReply = dataCommentTmp.filter((itm, idx) => {
        if (itm.commentParentId === idCommentParent && countReply < (isShowMore ? 3 : dataCommentTmp.length)) {
          countReply += 1;
          return itm;
        }
        return null;
      });

      newDataEventComment = [...newDataEventComment, ...newDataEventReply];

      newDataEventComment[idxCommentParent] = {
        ...newDataEventComment[idxCommentParent],
        isHasMoreReply: isShowMore,
      };

      return state.merge({
        communityDetailsComments: {
          ...communityDetailsComments,
          comments: [...newDataEventComment],
        },
      });
    }
    case types.POST_CREATE_OTG_PHOTO_COMMENT_LIKE_SUCCESS: {
      const { communityPhotoComments } = Immutable.asMutable(state);
      const { cmdId } = action.data;
      const newEventComment = [];
      communityPhotoComments.comments.forEach(itm => {
        if (itm.commentId === cmdId) {
          let newData = itm;
          newData = {
            ...newData,
            isLiked: true,
            likeCount: itm.likeCount + 1,
          };
          newEventComment.push(newData);
        } else {
          newEventComment.push(itm);
        }
      });
      return state.merge({
        communityPhotoComments: {
          ...communityPhotoComments,
          comments: [...newEventComment],
        },
      });
    }
    case types.POST_CREATE_COMMUNITY_COMMENT_LIKE_SUCCESS: {
      const { communityDetailsComments } = Immutable.asMutable(state);
      const { cmdId } = action.data;
      const newEventComment = [];
      communityDetailsComments.comments.forEach(itm => {
        if (itm.commentId === cmdId) {
          let newData = itm;
          newData = {
            ...newData,
            isLiked: true,
            likeCount: (itm.likeCount ? itm.likeCount : 0) + 1,
          };
          newEventComment.push(newData);
        } else {
          newEventComment.push(itm);
        }
      });
      return state.merge({
        communityDetailsComments: {
          ...communityDetailsComments,
          comments: [...newEventComment],
        },
      });
    }
    case types.DELETE_COMMUNITY_COMMENT_LIKE_SUCCESS: {
      const { communityDetailsComments } = Immutable.asMutable(state);
      const { cmdId } = action.data;
      const newEventComment = [];
      communityDetailsComments.comments.forEach(itm => {
        if (itm.commentId === cmdId) {
          let newData = itm;
          newData = {
            ...newData,
            isLiked: false,
            likeCount: itm.likeCount - 1 < 0 ? 0 : itm.likeCount - 1,
          };
          newEventComment.push(newData);
        } else {
          newEventComment.push(itm);
        }
      });
      return state.merge({
        communityDetailsComments: {
          ...communityDetailsComments,
          comments: [...newEventComment],
        },
      });
    }
    case types.DELETE_OTG_PHOTO_COMMENT_LIKE_SUCCESS: {
      const { communityPhotoComments } = Immutable.asMutable(state);
      const { cmdId } = action.data;
      const newEventComment = [];
      communityPhotoComments.comments.forEach(itm => {
        if (itm.commentId === cmdId) {
          let newData = itm;
          newData = {
            ...newData,
            isLiked: false,
            likeCount: itm.likeCount - 1 < 0 ? 0 : itm.likeCount - 1,
          };
          newEventComment.push(newData);
        } else {
          newEventComment.push(itm);
        }
      });
      return state.merge({
        communityPhotoComments: {
          ...communityPhotoComments,
          comments: [...newEventComment],
        },
      });
    }
    case types.POST_CREATE_UN_LIKE_COMMUNITY_SUCCESS: {
      // console.log(action)
      const { communityLikeUser, communityPhotoLikeUser } = Immutable.asMutable(state);
      const { id, dataKey, likeCount, index, isDetail, userInfo, isGalleryPhoto } = action;
      let newUserLike;
      if (isGalleryPhoto) {
        newUserLike = communityPhotoLikeUser.data.filter(itm => itm.userId !== userInfo.userId);
        state = state.setIn(['communityPhotoLikeUser', 'data'], newUserLike);
      } else {
        newUserLike = communityLikeUser.data.filter(itm => itm.userId !== userInfo.userId);
        state = state.setIn(['communityLikeUser', 'data'], newUserLike);
      }
      let currDataKey = dataKey;
      if (dataKey === COMMUNITY_DATA_KEY.OTG_VIDEO) {
        currDataKey = COMMUNITY_DATA_KEY.OTG;
      }
      if (index !== undefined && index !== null) {
        if (isDetail) {
          return state
            .setIn([currDataKey, 'data', index, 'contentItem', 'isMemberLike'], false)
            .setIn([currDataKey, 'data', index, 'contentItem', 'likeCount'], likeCount - 1)
            .setIn(['communityDetail', 'contentItem', 'isMemberLike'], false)
            .setIn(['communityDetail', 'contentItem', 'likeCount'], likeCount - 1);
        }
        if (currDataKey !== dataKey) {
          state = state
            .setIn([dataKey, 'data', index, 'contentItem', 'isMemberLike'], false)
            .setIn([dataKey, 'data', index, 'contentItem', 'likeCount'], likeCount - 1);
        }
        return state
          .setIn([currDataKey, 'data', index, 'contentItem', 'isMemberLike'], false)
          .setIn([currDataKey, 'data', index, 'contentItem', 'likeCount'], likeCount - 1);
      }
      if (isDetail) {
        return state
          .setIn(['communityDetail', 'contentItem', 'isMemberLike'], false)
          .setIn(['communityDetail', 'contentItem', 'likeCount'], likeCount - 1);
      }
      return state;
    }
    case types.POST_CREATE_LIKE_COMMUNITY_SUCCESS: {
      const { communityLikeUser, communityPhotoLikeUser } = Immutable.asMutable(state);
      const { id, dataKey, likeCount, index, isDetail, userInfo, isGalleryPhoto } = action;
      const newUserLike = [];
      const userLike = {
        ...userInfo,
        ageTitle: userInfo.ageTitle,
        isOnline: false,
        location: userInfo.locationInfo.suburb.StateName,
        memberLevel: userInfo.memberLevel,
        memberType: userInfo.memberType,
        memberTypeTitle: {
          ...userInfo.memberTypeTitle,
        },
        userId: userInfo.userId,
        userName: userInfo.displayName,
        mainPhoto: {
          fullUrl: userInfo.avatarFullUrl,
          thumbUrl: userInfo.avatarUrl,
        },
      };

      newUserLike.push(userLike);
      if (isGalleryPhoto) {
        communityPhotoLikeUser.data.map(itm => newUserLike.push(itm));
        state = state.setIn(['communityPhotoLikeUser', 'data'], newUserLike);
      } else {
        communityLikeUser.data.map(itm => newUserLike.push(itm));
        state = state.setIn(['communityLikeUser', 'data'], newUserLike);
      }
      let currDataKey = dataKey;
      if (dataKey === COMMUNITY_DATA_KEY.OTG_VIDEO) {
        currDataKey = COMMUNITY_DATA_KEY.OTG;
      }
      if (index !== undefined && index !== null && index !== -1) {
        if (isDetail) {
          return state
            .setIn(['communityDetail', 'contentItem', 'isMemberLike'], true)
            .setIn(['communityDetail', 'contentItem', 'likeCount'], likeCount + 1)
            .setIn([currDataKey, 'data', index, 'contentItem', 'isMemberLike'], true)
            .setIn([currDataKey, 'data', index, 'contentItem', 'likeCount'], likeCount + 1);
        }
        if (dataKey !== currDataKey) {
          state = state
            .setIn([dataKey, 'data', index, 'contentItem', 'isMemberLike'], true)
            .setIn([dataKey, 'data', index, 'contentItem', 'likeCount'], likeCount + 1);
        }
        return state
          .setIn([currDataKey, 'data', index, 'contentItem', 'isMemberLike'], true)
          .setIn([currDataKey, 'data', index, 'contentItem', 'likeCount'], likeCount + 1);
      }
      if (isDetail) {
        return state
          .setIn(['communityDetail', 'contentItem', 'isMemberLike'], true)
          .setIn(['communityDetail', 'contentItem', 'likeCount'], likeCount + 1);
      }
      return state;
    }
    case types.POST_COMMENT_OTG_PHOTO_SUCCESS: {
      const { communityPhotoComments, communityDetailPhoto, otgPhoto } = Immutable.asMutable(state);
      const updateObject = {
        isLoadingAlert: false,
        communityPhotoComments: {
          ...communityPhotoComments,
          comments: [
            {
              ...action.data,
            },
            ...communityPhotoComments.comments,
          ],
          totalItems:
            action.params.hasOwnProperty('commentParentID') && action.params.commentParentID === -1
              ? communityPhotoComments.totalItems
              : communityPhotoComments.totalItems + 1,
        },
        communityDetailPhoto: {
          ...communityDetailPhoto,
          contentItem: {
            ...(communityDetailPhoto.contentItem || {}),
            replyCount:
              action.params.hasOwnProperty('commentParentID') && action.params.commentParentID === -1
                ? communityDetailPhoto.contentItem?.replyCount
                : communityDetailPhoto.contentItem?.replyCount + 1,
          },
        },
      };

      if (otgPhoto?.data) {
        state = findAndUpdateReplyCount({
          array: otgPhoto.data,
          id: communityDetailPhoto.contentItem?.id,
          step: action.params.hasOwnProperty('commentParentID') && action.params.commentParentID === -1 ? 0 : 1,
          state,
          name: 'otgPhoto',
        });
      }

      return state.merge({ ...updateObject });
    }
    case types.POST_COMMENT_COMMUNITY_SUCCESS: {
      const { communityDetailsComments, communityDetail, article, stories, otg, otgPhoto } = Immutable.asMutable(state);
      let updateObject = {};

      if (communityDetail.contentItem) {
        updateObject = {
          ...updateObject,
          isLoadingAlert: false,
          communityDetail: {
            ...communityDetail,
            contentItem: {
              ...communityDetail.contentItem,
              replyCount:
                action.params.hasOwnProperty('commentParentID') && action.params.commentParentID === -1
                  ? communityDetail.contentItem.replyCount
                  : communityDetail.contentItem.replyCount + 1,
            },
          },
        };
      }
      if (communityDetailsComments) {
        updateObject = {
          ...updateObject,
          communityDetailsComments: {
            ...communityDetailsComments,
            comments: [
              {
                ...action.data,
              },
              ...communityDetailsComments.comments,
            ],
            totalItems:
              action.params.hasOwnProperty('commentParentID') && action.params.commentParentID === -1
                ? communityDetailsComments.totalItems
                : communityDetailsComments.totalItems + 1,
          },
        };
      }
      if (article?.data?.length > 0) {
        state = findAndUpdateReplyCount({
          array: article.data,
          id: communityDetail.contentItem.id,
          step: action.params.hasOwnProperty('commentParentID') && action.params.commentParentID === -1 ? 0 : 1,
          state,
          name: 'article',
        });
      }
      if (stories?.data?.length > 0) {
        state = findAndUpdateReplyCount({
          array: stories.data,
          id: communityDetail.contentItem.id,
          step: action.params.hasOwnProperty('commentParentID') && action.params.commentParentID === -1 ? 0 : 1,
          state,
          name: 'stories',
        });
      }
      if (otg?.data?.length > 0) {
        console.log('otg', otg);
        state = findAndUpdateReplyCount({
          array: otg.data,
          id: communityDetail.contentItem.id,
          step: action.params.hasOwnProperty('commentParentID') && action.params.commentParentID === -1 ? 0 : 1,
          state,
          name: 'otg',
        });
        console.log('state', state);
      }
      if (otgPhoto?.data?.length > 0) {
        state = findAndUpdateReplyCount({
          array: otgPhoto.data,
          id: communityDetail.contentItem.id,
          step: action.params.hasOwnProperty('commentParentID') && action.params.commentParentID === -1 ? 0 : 1,
          state,
          name: 'otgPhoto',
        });
      }
      return state.merge({ ...updateObject });
    }
    case types.DELETE_COMMUNITY_COMMENT_SUCCESS: {
      const { communityDetailsComments, communityDetail, article, stories, otg, otgPhoto } = Immutable.asMutable(state);
      const updateObject = {
        communityDetailsComments: {
          ...communityDetailsComments,
          comments: communityDetailsComments.comments.filter(item => item.commentId !== action.commentId),
          totalItems: communityDetailsComments.totalItems - 1,
        },
        communityDetail: {
          ...communityDetail,
          contentItem: {
            ...communityDetail.contentItem,
            replyCount: communityDetail.contentItem.replyCount - 1,
          },
        },
      };
      if (article?.data) {
        state = findAndUpdateReplyCount({ array: article.data, id: communityDetail.contentItem.id, step: -1, state, name: 'article' });
      }
      if (stories?.data) {
        state = findAndUpdateReplyCount({ array: stories.data, id: communityDetail.contentItem.id, step: -1, state, name: 'stories' });
      }
      if (otg?.data) {
        state = findAndUpdateReplyCount({ array: otg.data, id: communityDetail.contentItem.id, step: -1, state, name: 'otg' });
      }
      if (otgPhoto?.data) {
        state = findAndUpdateReplyCount({ array: otgPhoto.data, id: communityDetail.contentItem.id, step: -1, state, name: 'otgPhoto' });
      }

      return state.merge({ ...updateObject });
    }
    case types.DELETE_OTG_PHOTO_COMMENT_SUCCESS: {
      const { communityPhotoComments, communityDetailPhoto, otgPhoto } = Immutable.asMutable(state);
      const updateObject = {
        communityPhotoComments: {
          ...communityPhotoComments,
          comments: communityPhotoComments.comments.filter(item => item.commentId !== action.commentId),
          totalItems: communityPhotoComments.totalItems - 1,
        },
        communityDetailPhoto: {
          ...communityDetailPhoto,
          contentItem: {
            ...communityDetailPhoto.contentItem,
            replyCount: communityDetailPhoto.contentItem.replyCount - 1,
          },
        },
      };
      if (otgPhoto?.data) {
        state = findAndUpdateReplyCount({
          array: otgPhoto.data,
          id: communityDetailPhoto.contentItem.id,
          step: -1,
          state,
          name: 'otgPhoto',
        });
      }

      return state.merge({ ...updateObject });
    }
    case types.GET_COMMUNITY_LIKE_USER_SUCCESS: {
      const { communityLikeUser } = Immutable.asMutable(state);
      const { params, data } = action;
      const pageSize = params && params.size ? params.size : 20;
      const updateObject = {
        communityLikeUser: {
          data: !params || (params && !params.page) || (params && params.page === 1) ? data : [...communityLikeUser.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMore: data && data.length === pageSize,
        },
      };
      return state.merge({ ...updateObject });
    }
    case types.GET_OTG_PHOTOS_LIKE: {
      const { communityPhotoLikeUser } = Immutable.asMutable(state);
      const { params, data } = action;
      const pageSize = params && params.size ? params.size : 20;
      const updateObject = {
        communityPhotoLikeUser: {
          data: !params || (params && !params.page) || (params && params.page === 1) ? data : [...communityPhotoLikeUser.data, ...data],
          isLoading: false,
          page: (params && params.page) || 1,
          isHasMore: data && data.length === pageSize,
        },
      };
      return state.merge({ ...updateObject });
    }

    case types.GET_COMMUNITY_LIKE_USER_FAILED: {
      return (
        state
          .setIn(['communityLikeUser', 'isHasMore'], false)
          .setIn(['communityLikeUser', 'data'], [])
          // .setIn(["communityLikeUser", "page"], 1)
          .setIn(['communityLikeUser', 'isLoading'], false)
      );
    }

    case types.GET_STORY_AUTH_DETAIL: {
      return state.setIn(['stories', 'isHasMore'], false);
    }

    case types.DELETE_PARENT_OWNED_COMMENT: {
      const { from, commentId } = action.params;
      if (from && from === FROM_DELETE_COMMENT.STORY) {
        const { communityDetailsComments, communityDetail } = Immutable.asMutable(state);
        const findItem = communityDetailsComments.comments.find(itm => itm.commentId === commentId);
        const updateObject = {
          communityDetailsComments: {
            ...communityDetailsComments,
            comments: communityDetailsComments.comments.filter(item => item.commentId !== commentId),
            totalItems: communityDetailsComments.totalItems - 1,
          },
          communityDetail: {
            ...communityDetail,
            contentItem: {
              ...communityDetail.contentItem,
              replyCount:
                findItem && findItem.commentParentId === -1
                  ? communityDetail.contentItem.replyCount - 1
                  : communityDetail.contentItem.replyCount,
            },
          },
        };
        return state.merge({ ...updateObject });
      }
      return state;
    }

    default:
      return state;
  }
}

function findAndUpdateReplyCount({ array, id, step = 1, state, name }) {
  const indexSelected = array.findIndex(art => art.contentItem?.id === id);
  if (indexSelected !== -1) {
    const oldReply = array[indexSelected].contentItem.replyCount;
    return state.setIn([name, 'data', indexSelected, 'contentItem', 'replyCount'], oldReply + step);
  }
  return state;
}

function getDataStateOTGByKey(key, state) {
  return state[key || 'otgVideo'];
}
